/**
 * @returns true if the platform is Mac, iPad or iPhone
 */
export const isMacLike = (): boolean => {
    if (navigator.platform.startsWith("Mac") || navigator.platform === "iPhone") {
        return true;
    }

    return false;
};

export const platformModifierKey = isMacLike() ? "⌘" : "Ctrl";
const platformShiftKey = isMacLike() ? "⇧" : "Shift";

export const CreateEnvironmentModalKeyBinding = [platformModifierKey, "O"];
export const OpenSettingsPageKeyBinding = [platformModifierKey, ","];
export const ToggleSidebarKeyBinding = ["["];
export const ToggleAISidebarKeyBinding = ["]"];
export const ToggleDetailsPanelKeyBinding = ["]"];
export const OpenInEditorKeyBinding = [platformModifierKey, platformShiftKey, "A"];
export const KeyboardHelpKeyBinding = [platformModifierKey, "/"];

// Prompt input keyboard shortcuts
export const PromptInputModifierEnterKeyBinding = [platformModifierKey, "Enter"];
export const PromptInputModifierShiftEnterKeyBinding = [platformModifierKey, platformShiftKey, "Enter"];
